type TProviderOptionEditor =
  | { kind: 'boolean'; label: string }
  | { kind: 'number'; label: string; min: number; max: number }
  | { kind: 'text'; label: string; multiline: boolean };

const BOOLEAN_OPTIONS = new Set(['speaker_labels', 'multichannel', 'disfluencies']);
const ARRAY_OPTIONS = new Set(['speech_models', 'keyterms_prompt', 'custom_spelling']);

export const getProviderOptionEditor = (option: string): TProviderOptionEditor => {
  if (BOOLEAN_OPTIONS.has(option)) {
    return { kind: 'boolean', label: 'Boolean value' };
  }
  if (option === 'speakers_expected') {
    return { kind: 'number', label: 'Speaker count', min: 1, max: 10 };
  }
  if (ARRAY_OPTIONS.has(option)) {
    return { kind: 'text', label: 'JSON array', multiline: false };
  }
  if (option === 'speaker_options') {
    return { kind: 'text', label: 'JSON object', multiline: false };
  }
  return { kind: 'text', label: 'JSON string', multiline: false };
};
